/**
 * Configuración para integración con la app principal Ventaje.
 * BACKEND: Actualizar estas URLs según el entorno (dev/staging/prod).
 */

// URL de la página de login de Ventaje. Si el usuario elige "Iniciar sesión" en auth-choice,
// se redirige aquí con ?returnTo=<url_onboarding_con_loggedIn=1>. Tras login, Ventaje
// redirige al returnTo y el onboarding continúa en company-search.
export const VENTAJE_LOGIN_URL =
  process.env.REACT_APP_VENTAJE_LOGIN_URL || 'https://app.ventaje.com/login';

// URL de la app principal Ventaje. Cuando salesmanLoggedIn=true, se muestra "Volver a Ventaje"
// que enlaza aquí.
export const VENTAJE_APP_URL =
  process.env.REACT_APP_VENTAJE_APP_URL || 'https://app.ventaje.com';
